function RenderIfCMP({ cond, children ,falsyElement = <></>}) {
  return cond ? children : falsyElement;
}

export default RenderIfCMP
